<template>

  <main id="renew2_login" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="login_container">
      <div class="renew2_wrapper renew2_flex">
        <div class="login_contents">
          <div class="renew2_flex lead">
            <h2>ログイン</h2>
          </div>
          <p>Yagishの<a href="/terms" id="footer-link-terms" target="_blank">利用規約</a>、<a href="/privacy" class=""
              id="footer-link-terms" target="_blank">個人情報の取り扱いについて</a>に同意の上、ログインしてください。</p>
          <div class="login_block renew2_flex">
            <login-forms />
            <div class="login_block__02">
              <h3>まだ会員登録がお済みでない方</h3>
              <p>バックアップ情報等を<br class="renew2_sp">管理できるメェ〜</p>
              <button class="register" @click="goRegister">会員登録</button>
              <ul class="point renew2_flex renew2_sp_flex">
                <li class="point__item">
                  <img src="/static/renew2_img/point01.svg" alt="豊富なテンプレートをご用意">
                  <p>豊富なテンプレート<br class="renew2_sp">をご用意</p>
                </li>
                <li class="point__item">
                  <img src="/static/renew2_img/point02.svg" alt="老若男女問わず簡単">
                  <p>老若男女<br class="renew2_sp">問わず簡単</p>
                </li>
                <li class="point__item">
                  <img src="/static/renew2_img/point03.svg" alt="多くの方がご利用">
                  <p>多くの方が<br class="renew2_sp">ご利用</p>
                </li>
                <li class="point__item">
                  <img src="/static/renew2_img/point04.svg" alt="マイページで便利に！">
                  <p>マイページで<br class="renew2_sp">便利に！</p>
                </li>
              </ul>
              <a href="/info">yagishの使い方について</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>

</template>
<style lang="css" src="@/assets/css/renew_reset.css"></style>
<style lang="css" src="@/assets/css/renew2_style.css"></style>
<style lang="css" src="@/assets/css/renew2_login.css"></style>

<script>
// import LoginForms from '@/components/RenewLoginForms'
import LoginForms from '@/components/IdPwLoginForms'
import firebase from 'firebase/app'
export default {
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      fullscreenLoading: false
    }
  },
  created: function () {
    console.error(this.$globalVar.isShogai)
  },
  computed: {
  },
  mounted: function () {
  },
  methods: {
    goRegister: function () {
      this.$router.push('/mregister')
    },
    setFullscreenLoading: function (val) {
      this.fullscreenLoading = val
    },
    loginIdPw: function (id, pw) {
      this.fullscreenLoading = true
      this.$firebase.signInEmailPasswd(id, pw)
    },
    authStateChangedNewLogin: async function () {
      const urlParams = new URLSearchParams(window.location.search);
      var from_page = urlParams.get("frompage");
      if (from_page) {
        this.$router.push('/format/' + from_page + '/edit/output')
      } else {
        // this.$router.push('/mypage')
        location.href = "/mypage"
        // this.$router.replace('/mypage')
        // window.location.reload()
      }
      console.log('new login created')
    }
  },
  watch: {},
  beforeMount: function () {
    // firebase.auth().onAuthStateChanged((user) => {
    //   if (user) {    
    //   console.log('New Login onAuthStateChanged on')
    //   }
    // })
    this.$eventHub.$on('login-id-passwd', this.loginIdPw)
    this.$eventHub.$on('set-fullscreen-loading', this.setFullscreenLoading)
    this.$eventHub.$on('login_redirect_function', this.authStateChangedNewLogin)
  },
  destroyed: function () {
    // firebase.auth().onAuthStateChanged((user) => {
    //   console.log('New Login onAuthStateChanged off')
    // })
    this.$eventHub.$off('login-id-passwd', this.loginIdPw)
    this.$eventHub.$off('set-fullscreen-loading', this.setFullscreenLoading)
    this.$eventHub.$off('login_redirect_functionn', this.authStateChangedNewLogin)
  }
}
</script>
